

const companyData = [
    {
        question: "Matching de datos",
        answer: "Olvídate de filtrar montones de CVs irrelevantes y de ser ghosteado. Nuestro sistema te conecta sólo con candidatos que realmente encajan con tu búsqueda, rol de la oferta y cultura. ¡Más fácil y sin dramas!"
    },
    {
        question: "Más allá del CV",
        answer: "Descubre a los candidatos a través de sus historias profesionales y competencias en un CV interactivo. Nuestro sistema te revelará talentos ocultos que podrían encajar mejor con la cultura de tu empresa, antes imposibles de detectar."
    },
    {
        question: "Todo sobre Fit Cultural",
        answer: "Nuestro sistema no solo busca el match con la oferta, también analiza el encaje cultural con tu empresa, usando la información proporcionada para evaluar al candidato de manera más certera."
    },
    {
        question: "Selección ágil y precisa",
        answer: "Gracias al onboarding, obtenemos información que antes solo surgía en una primera llamada o entrevista. Acortamos el proceso de selección con algoritmos, asegurando el match perfecto solo con los candidatos correctos. ¡Menos entrevistas, más aciertos!"
    },
    {
        question: "Un feedback a la altura",
        answer: "Gracias a nuestro sistema de recompensas y seguimiento de evaluaciones, generamos feedbacks constructivos listos para tu aprobación, manteniendo al candidato informado y motivado. Esto asegura una comunicación ágil y favorece a tu imagen como empresa."
    },
    {
        question: "Talento a medida",
        answer: "No somos un simple filtrado de datos de LinkedIn o portales de empleo. Usamos un algoritmo propio que analiza y filtra la información de ambas partes de manera precisa, para presentarte al candidato adecuado y alineado a tus necesidades. ¡Menos ruido, más precisión!"
    },
]

export default companyData;